import bilAPI from "../api";

export const getPurposes = ({ signal }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/question_purposes/`, { signal })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error");
        });
    } catch (error) {
      reject("system error");
    }
  });
};
